import { Einheit } from 'app/models/core/einheit.model';
import { BnrGpPosModel } from '../bnr.gp.pos.model';
import { PosUnDef } from '../gp';
const posDef: BnrGpPosModel[] = [];

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'ausMaxi',
		posText: 'Systematische Vertriebsunterstützung I',
		planKey: 'vertriebsunterstz_i',
		einheit: Einheit.quali,
		posDesc: `Aktive Unterstützung der ABV Hauptverwaltung bei strategischen Schwerpunkten zur systematischen Vertriebssteuerung in den Agenturen.`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'ausMaxi',
		posText: 'Hardwarebestellung im Verantwortungsbereich inklusive Neueinstellungen',
		planKey: 'steigerung_kundenvertrauen_i',
		einheit: Einheit.quali,
		posDesc: `Maßnahmen entwickeln, um ein unter wirtschaftlichen Gesichtspunkten nachhaltiges Bestellverhalten zu fördern und zu controllen.
Berücksichtigung von Handlungsrichtlinien und
Leitfäden für regelmäßig anfallende Bestell-
und Abbauvorgänge.
Empfehlen von zukunftsorientierten, technischen
Verkaufsmöglichkeiten für den Vertriebsweg.`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'ausMaxi',
		posText: 'Vertreteraktivierung in den Wachstumsdimensionen',
		planKey: 'vertreteraktivierung',
		einheit: Einheit.quali,
		posDesc: `Multiplikator:in und Ansprechpartner:in für Führungskräfte innerhalb der VD für den
strategischen Einsatz aller digitalen und analogen
Instrumente der Wachstumsdimensionen.
Verantwortung für die Nutzung und Etablierung
der Instrumente durch gezielte Einsteuerung von
Neuerungen und Best-Practices.
Austausch über laufendes Feedback an
betreuenden Fachabteilungen`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'ausMaxi',
		posText: 'Mitarbeiterentwicklung',
		planKey: 'mitarbeiterentwicklung',
		einheit: Einheit.quali,
		posDesc: `Fachliche und persönliche Weiterentwicklung der im Verantwortungsbereich zugeordneten Mitarbeiter:innen.`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'max10k',
		posText: 'Systematische Vertriebsunterstützung II',
		planKey: 'vertriebsunterstz_ii',
		einheit: Einheit.quali,
		posDesc: `Multiplikator:in und erster Ansprechpartner:in für Geschäftsstellen zur DVS. Promotor für
		die nachhaltige Implementierung der DVS als strategisches Instrument zur Zielplanung in den
		Geschäftsstellen.`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 10010,
		group: 'max10k',
		posText: 'Sichtbar sein digital.persönlich - Steigerung der digitalen Sichtbarkeit I',
		berichtePath: 'kunde/sm/gupmultigp/',
		einheit: Einheit.proz,
		boniStufen: 2,
		posDesc: `Steigerung der Anzahl GV/HV mit kontinuierlichem Zuwachs an Google Bewertungen im Verantwortungsbereich Stichtag der Bemessungsgrundlage für das Jahresziel ist der GV/HV Bestand zum 01.01.2026`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 10020,
		group: 'max10k',
		posText: 'Sichtbar sein digital.persönlich - Steigerung der digitalen Sichtbarkeit II',
		berichtePath: 'kunde/sm/viewsmultigp/',
		einheit: Einheit.proz,
		boniStufen: 2,
		posDesc: `Anzahl GV/HV mit mehr als 30.000 Sichtkontakten über die Social Media Kanäle Facebook und Instagram Stichtag der Bemessungsgrundlage für das Jahresziel ist der GV/HV Bestand zum 01.01.2026`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'max10k',
		posText: 'Jeden Kontakt nutzen I - Unterstützung und Beratung bei der Einrichtung des neuen technischen Arbeitsplatzes',
		berichtePath: 'bestand/fit/amisnowaufgaben/',
		einheit: Einheit.quali,
		posDesc: `Multiplikator:in und Ansprechpartner:in für den betreuenden Außendienst über die strategische und fachliche Ausrichtung des technischen Vertriebsarbeitsplatzes. Verantwortung für die Etablierung von Kommunikations- und Schulungskonzepten zum sicheren Einsatz des technischen Arbeitsplatzes zur Steigerung der Nettovertriebszeit. Förderung durch Integration in den Arbeitsalltag der Agenturen im Verantwortungsbereich.`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'max10k',
		posText: 'Jeden Kontakt nutzen II - Unterstützung bei der fachlichen Weiterentwicklung von AMIS.NOW',
		berichtePath: 'bestand/fit/amisnowaufgaben/',
		einheit: Einheit.quali,
		posDesc: `Multiplikator:in und Ansprechpartner:in für den betreuenden Außendienst zur strategischen und fachlichen Ausrichtung von AMIS.NOW. Verantwortung für die Etablierung von Kommunikations- und Schulungskonzepten zur erfolgreichen Weiterentwicklung und Breiteneinsatzes bei allen GV/HV im Verantwortungsbereich. Förderung von Verkaufschancen durch Etablierung von AMIS.NOW Aufgaben in den Arbeitsalltag der Agenturen im Verantwortungsbereich.`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'max10k',
		posText: 'Jeden Kontakt nutzen III - Förderung von Vertriebschancen im Agenturteam',
		berichtePath: 'bestand/fit/amisnowaufgaben/',
		einheit: Einheit.quali,
		posDesc: `Multiplikator:in und Ansprechpartner:in für Service-to-Sale. Förderung von Vertriebschancen im gesamten Agenturteam durch Einsteuerung und Nachhalten geeigneter Maßnahmen im Verantwortungsbereich.`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 10030,
		group: 'max10k',
		posText: 'Jeden Kunden kontaktieren - Steigerung der Cross-Selling-Quote und Kundenbindung',
		berichtePath: 'kunde/akuma/gp/',
		einheit: Einheit.proz,
		posDesc: `Anzahl GV/HV mit wiederkehrender AKUMA Nutzung in der VD plus Anzahl GV/HV an AKUMA.Prime (wiederkehrende AKUMA Planer Nutzung von mindestens 12 Wochen im Jahr 2026). Stichtag der Bemessungsgrundlage für das Jahresziel ist der GV/HV Bestand zum 01.01.2026`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2320160, // wird geliefert
		group: 'max10k',
		posText: 'Immer da sein - Neuanmeldungen Meine Allianz',
		berichtePath: 'bestand/adz/fit/maz/',
		einheit: Einheit.stck,
		posDesc: `Steigerung der Durchdringung von Kunden mit Meine Allianz im Bestand Basis Jahresanfangsbestand 01.01.2026`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'max10k',
		posText: 'Immer da sein - Öffnungszeiten effektiv verlängern',
		planKey: 'openinghours',
		einheit: Einheit.quali,
		posDesc: `Förderung und Multiplikation von Serviceleistungen im Bereich Inbound. Förderung von Erreichbarkeit im Verantwortungsbereich durch Einsteuerung und Nachhalten geeigneter Maßnahmen.`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 10040,
		group: 'max8k',
		posText: 'Neue Kunden finden - Förderung der Neukundengewinnung',
		berichtePath: 'kunde/leadnow/consecutive/',
		einheit: Einheit.proz,
		boniStufen: 2,
		posDesc: `Steigerung der Neukundengewinnung mit AMIS.NOW.Leads. Anzahl Agenturen von AMIS.NOW.Leads im Verantwortungsbereich mit einer Teilnahme von mind. 12 Wochen am Stück Stichtag der Bemessungsgrundlage für das Jahresziel ist der GV/HV Bestand zum 01.01.2026`,
	}),
);

export const LdpPositionen = posDef;
